// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__7k4HD","leftBadge":"Badge_leftBadge__yHRmT","rightBadge":"Badge_rightBadge__qt0e7","centered":"Badge_centered__jzeqo","pill":"Badge_pill__PMiwW"};